import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as display from '../../../../display'
import type { Feature } from '../feature'

const SUCCESS_MESSAGE =
  'File deleted. Knowledge base indexing has been queued and may take a few minutes.'

/** Announces a completed deletion. */
export const handleDeleteSuccess = store.effects.create(
  (feature: Feature, toasterFeature: display.toaster.Feature) =>
    feature.actions.delete.success.observe().pipe(
      rxjs.tap(() =>
        toasterFeature.actions.show
          .from('Admin.KnowledgeBases.Operation')
          .dispatch({
            toast: {
              description: SUCCESS_MESSAGE,
              name: 'File deleted',
              style: ents.core.display.Style.Success,
            },
          }),
      ),
      rxjs.ignoreElements(),
    ),
)
